// Flat default system fee applied to new "nurse" deployments for
// franchise-Expert locations (see NO_SYSTEM_FEE_LOCATION_IDS below).
export const DEFAULT_SYSTEM_FEE = 50.0;

// Locations that get no default system fee, e.g. because they are the HQ /
// have their own pricing. Add further ids here as they come up.
// Zentrale, Region HH, Region München und Recklinghausen / Borken
export const NO_SYSTEM_FEE_LOCATION_IDS = [8, 17, 80, 105];
